var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-subheader',{staticClass:"px-0"},[_vm._v("Central de Ajuda")]),_c('v-card',{attrs:{"width":"100%"}},[_c('help-center-header'),_c('system-video')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }